import React from 'react'
import styled from 'styled-components'
import DataTable from 'react-data-table-component'
import { ArrowDown } from 'react-feather'
import { Spinner, UncontrolledTooltip } from 'reactstrap'
import { useIntl, FormattedMessage } from 'react-intl'

import { Loading } from '../styles'

const customStyles = {
  headRow: {
    style: {
      backgroundColor: '#f8f8f8',
    },
  },
}

const locationCell = (row, index) => {
  return (
    <LocationDiv>
      <div>
        <span id={`location-name-cell-${index}`}>{row.location}</span>
        {row?.storecode && (
          <span
            className="storecode-tag"
            id={`location-storecode-cell-${index}`}
          >
            {row.storecode}
          </span>
        )}
      </div>
      <div className="text-muted" id={`location-address-cell-${index}`}>
        {row.address} - {row.city}
      </div>
      <UncontrolledTooltip target={`location-name-cell-${index}`}>
        {row.location}
      </UncontrolledTooltip>
      <UncontrolledTooltip target={`location-address-cell-${index}`}>
        {row.address} - {row.city}
      </UncontrolledTooltip>
      {row?.storecode && (
        <UncontrolledTooltip target={`location-storecode-cell-${index}`}>
          {row.storecode}
        </UncontrolledTooltip>
      )}
    </LocationDiv>
  )
}

const columns = [
  {
    id: 'location',
    name: <FormattedMessage id="Location" />,
    width: '50%',
    selector: row => row.location,
    cell: locationCell,
    sortable: true,
  },
  {
    id: 'direction',
    name: <FormattedMessage id="Directions" />,
    selector: row => +row.direction,
    width: '10%',
    compact: true,
    center: true,
    sortable: true,
  },
  {
    id: 'calls',
    name: <FormattedMessage id="Calls" />,
    selector: row => +row.calls,
    width: '10%',
    compact: true,
    center: true,
    sortable: true,
  },
  {
    id: 'website',
    name: <FormattedMessage id="Website" />,
    selector: row => +row.website,
    width: '10%',
    compact: true,
    center: true,
    sortable: true,
  },
  {
    id: 'reviews',
    name: <FormattedMessage id="Reviews" />,
    selector: row => +row.reviews,
    width: '10%',
    compact: true,
    center: true,
    sortable: true,
  },
  {
    id: 'questions',
    name: <FormattedMessage id="Questions" />,
    selector: row => +row.questions,
    width: '10%',
    compact: true,
    center: true,
    sortable: true,
  },
]

const LoadingData = () => {
  return (
    <Loading>
      <Spinner color="primary" size="lg" />
    </Loading>
  )
}

export const EngagementPage = ({
  loading,
  data,
  total,
  setPageParams,
  setLimitParams,
  setSortParams,
}) => {
  const intl = useIntl()

  const paginationComponentOptions = {
    rowsPerPageText: intl.formatMessage({ id: 'table.pagination' }),
    rangeSeparatorText: intl.formatMessage({ id: 'table.rangeSeparator' }),
    selectAllRowsItem: false,
  }

  return (
    <ReputationDiv>
      <DataTable
        actions
        keyField="engagement"
        className="dataTable-custom"
        columns={columns}
        data={data}
        noHeader
        pagination
        paginationServer
        paginationTotalRows={total}
        sortIcon={<ArrowDown size="4" />}
        onChangePage={setPageParams}
        onChangeRowsPerPage={setLimitParams}
        sortServer
        onSort={setSortParams}
        progressPending={loading}
        progressComponent={<LoadingData />}
        customStyles={customStyles}
        paginationComponentOptions={paginationComponentOptions}
      />
    </ReputationDiv>
  )
}

const ReputationDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin: 2em 0;

  h4 {
    font-size: 1.5em;
    color: #767676;
  }
`

const LocationDiv = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 100%;

  .storecode-tag {
    background-color: #f7fafc;
    color: #4a5568;
    border-radius: 4px;
    padding: 0.1rem 0.5rem;
    font-family: 'Inter', sans-serif;
    font-size: 0.9rem;
    font-weight: 500;
  }

  > div {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;

    span {
      margin-right: 0.5em;
    }
  }
`
